import React from "react";
import { Input } from "semantic-ui-react";
import { Loading } from "../../components/panels";
import { PhosphorFloppyButton, PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

interface Props {
  onEdit: (fileId: number, newName: string, visibleToExternal: boolean) => void
  onDelete: (file: server.dto.File) => void
  initialFile: server.dto.File
  config: server.dto.LinkedFilePanelConfig
}

const FileEdit = (props: Props) => {
  const [name, setName] = React.useState<string>(props.initialFile.name);
  const [visibleToExternal, setVisibleToExternal] = React.useState<boolean>(props.initialFile.visibleToExternal);
  const [isSaving, setIsSaving] = React.useState<boolean>(false);
  const [hasError, setHasError] = React.useState<boolean>(false);

  const fileId = "fileName_" + props.initialFile.id;
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      onSave();
      e.preventDefault();
    }
  };

  const onSave = () => {
    const hasError = name.trim() === "";
    setHasError(hasError);
    if (hasError) {
      return;
    }
    setIsSaving(true);
    props.onEdit(props.initialFile.id, name, visibleToExternal);
  };

  return <div>
    <div className="grow1">
      <div className="flex align-center">
        <div className="grow1">
          <Input
            error={hasError}
            onKeyDown={onKeyDown}
            maxLength={serverReference.constants.file.maxNameLength}
            style={{ width: "100%" }}
            id={"fileId" + fileId}
            value={name}
            onChange={(_, { value }) => {
              setName(value);
              setHasError(false);
            }} />
        </div>
        <div>
          <label htmlFor={"fileId" + fileId} style={{ marginLeft: 5 }}>.{props.initialFile.extension}</label>
        </div>
      </div>
      {props.config.showVisibleToExternalCheckbox && <div className="margin-top-small">
        <Checkbox checked={visibleToExternal} onChange={() => { setVisibleToExternal(!visibleToExternal); }} label={RESX.GeneralLabels.VisibleToExternalUsers} />
      </div>}
    </div>
    <PhosphorTrashButton
      layout="in-square"
      onClick={() => { props.onDelete(props.initialFile); }}
    />
    <div>
      {!isSaving && <PhosphorFloppyButton
        layout="in-square"
        onClick={onSave}
      />}
      {isSaving && <Loading />}
    </div>
  </div >;
};

export default FileEdit;